import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      src: "assets/administrator/LogoMenuLight.svg",
      alt: "Logo Artistic Vision",
      class: "logo"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/administrator/clients",
        class: _normalizeClass(["option", { 'active-option': _ctx.isClientsRoute }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: "assets/administrator/ClientsLight.svg",
            alt: "Clientes",
            class: _normalizeClass(["icon clients", { 'active-icon': _ctx.isClientsRoute }])
          }, null, 2),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "option-name" }, "Clientes", -1))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/administrator/deliveries",
        class: _normalizeClass(["option", { 'active-option': _ctx.isDeliveriesRoute }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: "assets/administrator/DeliveriesLight.svg",
            alt: "Entregas",
            class: _normalizeClass(["icon deliveries", { 'active-icon': _ctx.isDeliveriesRoute }])
          }, null, 2),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "option-name" }, "Entregas", -1))
        ]),
        _: 1
      }, 8, ["class"])
    ])
  ]))
}